import { API_URL } from '../config/connect';

export const getFaq = async () => {
    const response = await fetch(`${API_URL}/api/v1/faq`, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
    });

    if (!response.ok) {
        throw new Error(`FAQ fetch failed: ${response.status}`);
    }

    return response.json();
};
